import { IDocumentValidation } from './../interfaces/document-validation-interface';
import { Component } from '@angular/core';

@Component({
  selector: 'app-radicar',
  templateUrl: './radicar.component.html',
  styleUrls: ['./radicar.component.scss'],
})
export class RadicarComponent {
  public isShowingPQRForm = false;
  public documentInformation: IDocumentValidation;

  public showPQRForm(value: IDocumentValidation): void {
    if (value) {
      this.isShowingPQRForm = true;
      this.documentInformation = value;
    }
  }

  public handlePqrSent(): void {
    this.isShowingPQRForm = false;
  }
}
